// OMNISEND TRANSLATION SCRIPT
(function () {
  const FORM_ID = 'omnisend-form-699daa6c99b8b61cd187e71a';

  /* Use your theme font variable or replace with a fixed stack */
  const FONT_FAMILY = 'var(--font-body-family), Arial, sans-serif';
  // Example fixed stack:
  // const FONT_FAMILY = '"Inter", -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif';

  function isEnglish() {
    const lang = (document.documentElement.getAttribute('lang') || '').toLowerCase();
    return lang === 'en' || lang.startsWith('en-');
  }

  /* Exact text replacements (LT -> EN) */
  const textMap = new Map([
    ['PRANEŠTI, KAI PREKĖ VĖL BUS SANDĖLYJE', 'NOTIFY ME WHEN THIS ITEM IS BACK IN STOCK'],
    ['El. Paštas', 'Email'],
    ['Privalomas laukas', 'This field is required'],
    ['El. pašto adrese turi būti @ ir galiojantis domenas', 'Please enter a valid email address'],
    ['PRANEŠTI MAN', 'NOTIFY ME'],
    ['Registracija sėkminga. Kai prekė atsiras sandėlyje gausite el. laišką', 'Registration successful. We will email you when the item is back in stock']
  ]);

  /* Regex fallback replacements (prevents breakage if spacing/case changes a bit) */
  const phraseReplacements = [
    [/Pranešti,\s*kai prekė vėl bus sandėlyje/gi, 'Notify me when this item is back in stock'],
    [/El\.\s*Paštas/gi, 'Email'],
    [/Privalomas laukas/gi, 'This field is required'],
    [/El\.\s*pašto adrese turi būti @ ir galiojantis domenas/gi, 'Please enter a valid email address'],
    [/Pranešti man/gi, 'Notify me'],
    [/Registracija sėkminga\.\s*Kai prekė atsiras sandėlyje gausite el\.\s*laišką/gi, 'Registration successful. We will email you when the item is back in stock']
  ];

  function ensureFontStyleTag() {
    const styleId = 'omnisend-font-force-' + FORM_ID;
    let styleTag = document.getElementById(styleId);

    if (!styleTag) {
      styleTag = document.createElement('style');
      styleTag.id = styleId;
      document.head.appendChild(styleTag);
    }

    styleTag.textContent = `
      #${FORM_ID},
      #${FORM_ID} * {
        font-family: ${FONT_FAMILY} !important;
      }

      #${FORM_ID} input::placeholder,
      #${FORM_ID} textarea::placeholder {
        font-family: ${FONT_FAMILY} !important;
      }
    `;
  }

  function applyOmnisendFont(root) {
    if (!root) return;

    ensureFontStyleTag();

    // Force inline font on all descendants to beat Omnisend's injected styles
    root.style.setProperty('font-family', FONT_FAMILY, 'important');

    const els = root.querySelectorAll('*:not(style):not(script)');
    els.forEach((el) => {
      try {
        el.style.setProperty('font-family', FONT_FAMILY, 'important');
      } catch (e) {}
    });
  }

  function replaceTextContent(str) {
    if (!str) return str;

    const trimmed = str.trim();

    // Exact match first (most reliable)
    if (textMap.has(trimmed)) {
      return str.replace(trimmed, textMap.get(trimmed));
    }

    // Fallback regex replacements
    let out = str;
    phraseReplacements.forEach(([regex, replacement]) => {
      out = out.replace(regex, replacement);
    });

    return out;
  }

  function translateOmnisendToEnglish(root) {
    if (!root || !isEnglish()) return;

    // Translate text nodes
    const walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT, {
      acceptNode(node) {
        if (!node.nodeValue || !node.nodeValue.trim()) return NodeFilter.FILTER_REJECT;

        const parent = node.parentElement;
        if (!parent) return NodeFilter.FILTER_REJECT;

        const tag = parent.tagName;
        if (tag === 'STYLE' || tag === 'SCRIPT') return NodeFilter.FILTER_REJECT;

        return NodeFilter.FILTER_ACCEPT;
      }
    });

    const textNodes = [];
    while (walker.nextNode()) {
      textNodes.push(walker.currentNode);
    }

    textNodes.forEach((node) => {
      const updated = replaceTextContent(node.nodeValue);
      if (updated !== node.nodeValue) {
        node.nodeValue = updated;
      }
    });

    // Translate placeholders
    root.querySelectorAll('input[placeholder], textarea[placeholder]').forEach((el) => {
      const current = el.getAttribute('placeholder');
      const next = replaceTextContent(current);
      if (next !== current) el.setAttribute('placeholder', next);
    });

    // Translate aria-labels if needed
    root.querySelectorAll('[aria-label]').forEach((el) => {
      const current = el.getAttribute('aria-label');
      const next = replaceTextContent(current);
      if (next !== current) el.setAttribute('aria-label', next);
    });

    // Translate value for input buttons if any appear later
    root.querySelectorAll('input[type="submit"], input[type="button"], input[type="reset"]').forEach((el) => {
      const current = el.value;
      const next = replaceTextContent(current);
      if (next !== current) el.value = next;
    });
  }

  function applyAll() {
    const root = document.getElementById(FORM_ID);
    if (!root) return;

    applyOmnisendFont(root);
    translateOmnisendToEnglish(root);
  }

  function runRepeatedly() {
    applyAll();
    setTimeout(applyAll, 200);
    setTimeout(applyAll, 800);
    setTimeout(applyAll, 2000);
    setTimeout(applyAll, 5000);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', runRepeatedly);
  } else {
    runRepeatedly();
  }

  // Watch Omnisend rerenders / validation / success message swaps
  const observer = new MutationObserver((mutations) => {
    const root = document.getElementById(FORM_ID);
    if (!root) return;

    let changedInsideForm = false;

    for (const m of mutations) {
      const target = m.target;
      if (target && root.contains(target)) {
        changedInsideForm = true;
        break;
      }

      for (const n of m.addedNodes) {
        if (n.nodeType === 1 && root.contains(n)) {
          changedInsideForm = true;
          break;
        }
      }

      if (changedInsideForm) break;
    }

    if (changedInsideForm) applyAll();
  });

  observer.observe(document.documentElement, {
    childList: true,
    subtree: true,
    attributes: true,
    characterData: true
  });
})();
// OMNISEND TRANSLATION SCRIPT


// OMNISEND HIDE SHOW FORM

document.addEventListener('DOMContentLoaded', function () {
  const productSection = document.querySelector('[id^="ProductSection-"]') || document;

  const variantBlock = productSection.querySelector('variant-radios, variant-selects');
  if (!variantBlock) return;

  const variantsJson = variantBlock.querySelector('script[type="application/json"]');
  if (!variantsJson) return;

  let variants = [];

  try {
    variants = JSON.parse(variantsJson.textContent);
  } catch (e) {
    console.warn('Could not parse variant JSON', e);
    return;
  }

  const omnisendBlock =
    productSection.querySelector('[id^="shopify-block-"][id*="omnisend"]') ||
    productSection.querySelector('[id^="omnisend-embedded"]')?.closest('.shopify-block') ||
    productSection.querySelector('[id^="omnisend-embedded"]');

  if (!omnisendBlock) return;

  function getCurrentVariantId() {
    const productForm = productSection.querySelector('form[action="/cart/add"] input[name="id"]');
    if (productForm && productForm.value) {
      return Number(productForm.value);
    }

    const checkedOptions = Array.from(
      variantBlock.querySelectorAll('input[type="radio"]:checked')
    ).map(input => input.value);

    const selectedOptions = Array.from(
      variantBlock.querySelectorAll('select')
    ).map(select => select.value);

    const selectedValues = checkedOptions.length ? checkedOptions : selectedOptions;

    const matchedVariant = variants.find(variant => {
      return variant.options.every((option, index) => option === selectedValues[index]);
    });

    return matchedVariant ? matchedVariant.id : null;
  }

  function toggleOmnisendForm() {
    const currentVariantId = getCurrentVariantId();
    const currentVariant = variants.find(variant => variant.id === currentVariantId);

    if (!currentVariant) return;

    if (currentVariant.available) {
      omnisendBlock.style.display = 'none';
    } else {
      omnisendBlock.style.display = '';
    }
  }

  toggleOmnisendForm();

  productSection.addEventListener('change', function (event) {
    if (
      event.target.matches('input[type="radio"]') ||
      event.target.matches('select')
    ) {
      setTimeout(toggleOmnisendForm, 100);
      setTimeout(toggleOmnisendForm, 300);
    }
  });

  productSection.addEventListener('click', function () {
    setTimeout(toggleOmnisendForm, 100);
    setTimeout(toggleOmnisendForm, 300);
  });

  document.addEventListener('variant:change', toggleOmnisendForm);
  document.addEventListener('variantChange', toggleOmnisendForm);
});